<template>
  <div>
    <v-icon aria-label="Log in" @click="loginAuth">{{
      authenticated ? "mdi-account-circle" : "mdi-login-variant"
    }}</v-icon>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import moment from "moment";
import apiHelper from "@/helpers/apiHelper";

export default {
  name: "LoginIcon",
  computed: {
    ...mapGetters(["authenticated", "visitBookingEnabled"]),
  },
  methods: {
    ...mapMutations(["updatePreCasAuthState"]),
    loginAuth() {
      //Home(visitBookingEnabled) -> LoginOptions -> 1)Home(once success login), 2)Account(icon)
      //Home(!visitBookingEnabled) -> CAS login
      if (this.authenticated) {
        this.$router.push({ name: "Account" });
      } else {
        this.updatePreCasAuthState({
          routeName: this.$route.name,
          time: moment(),
        });
        if (this.visitBookingEnabled) {
          this.$router.push({ name: "LoginOptions" });
        } else {
          apiHelper.casAuth();
        }
      }
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.authenticated) {
        return next({ name: "Account" });
      } else {
        if (vm.visitBookingEnabled) {
          next();
        } else {
          apiHelper.casAuth();
        }
      }
    });
  },
};
</script>

<style>
#login-page .v-input__prepend-inner .v-icon {
  color: white !important;
}
</style>
